import sample from "./codeSample";

export default (sampleConfig) => {

	const newCodeSample = sample; //.toString();

	return newCodeSample.replace("$config",
		JSON.stringify(sampleConfig, null, 4)
			.replace(/"([^(")\-,"\s]+)":/g, "$1:"));
};
